import { createContext } from "react";

//form error

//form info
export interface ITopicClusterFormContext {
  mode: "Edit" | "Add";
}
export const TopicClusterFormContext = createContext<ITopicClusterFormContext | null>(null);
